import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	user: localStorage.getItem("userId")
		? {
				_id: localStorage.getItem("userId"),
				firstName: localStorage.getItem("username"),
				lastName: "",
				role: localStorage.getItem("role"),
	  		}	
		: null,
	error: "",
	loading: false,
};

// ✅ ADD STAFF
export const addStaff = createAsyncThunk(
	"user/addStaff",
	async (values, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
					Authorization: `Bearer ${localStorage.getItem("access-token")}`,
				},
				url: `/staff-details/create`, // ✅ FIXED
				data: {
					...values,
				},
			});
			toast.success("Registration successful");
			return { data, message: "success" };
		} catch (error) {
			toast.error("Error in adding staff try again");
			return rejectWithValue(error.response?.data || error.message); // ✅ FIXED
		}
	}
);

// ✅ DELETE STAFF
export const deleteStaff = createAsyncThunk(
	"user/deleteStaff",
	async (id, { rejectWithValue }) => {
		try {
			const resp = await axios({
				method: "patch",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
					Authorization: `Bearer ${localStorage.getItem("access-token")}`,
				},
				url: `/staff-details/${id}`, // ✅ FIXED
				data: {
					status: false,
				},
			});
			return resp.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message); // ✅ FIXED
		}
	}
);

// ✅ LOAD SINGLE STAFF
export const loadSingleStaff = createAsyncThunk(
	"user/loadSingleStaff",
	async (id, { rejectWithValue }) => {
		try {
			const { data } = await axios.get(`/staff-details/${id}`, {
  				headers: {
    				Authorization: `Bearer ${localStorage.getItem("access-token")}`,
  				},
			}); // ✅ FIXED
			return data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message); // ✅ FIXED
		}
	}
);

// ✅ LOAD ALL STAFF
export const loadAllStaff = createAsyncThunk(
	"user/loadAllStaff",
	async ({ status }, { rejectWithValue }) => {
		try {
			const { data } = await axios.get(`/staff-details`, {
  				headers: {
    				Authorization: `Bearer ${localStorage.getItem("access-token")}`,
  				},
			});
			return data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message); // ✅ FIXED
		}
	}
);

// ✅ LOGIN USER
export const addUser = createAsyncThunk(
	"user/addUser",
	async (values, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
					Authorization: `Bearer ${localStorage.getItem("access-token")}`,
				},
				url: `/api/auth/login`, // ✅ FIXED
				data: {
					...values,
				},
			});
			localStorage.setItem("access-token", data.token);
			localStorage.setItem("role", data.role);
			localStorage.setItem("user", data.userName);
			localStorage.setItem("id", data.id);
			localStorage.setItem("isLogged", true);
			toast.success(" Login Successfully Done");

			return { data, message: "success" };
		} catch (error) {
			toast.error("Incorrect Username or Password !");
			return rejectWithValue(error.response?.data || error.message); // ✅ FIXED
		}
	}
);

// ✅ UPDATE USER
export const updateUser = createAsyncThunk(
	"user/updateUser",
	async ({ id, values }, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "put",
				url: `/api/auth/${id}`, // ✅ FIXED
				headers: {
    				Authorization: `Bearer ${localStorage.getItem("access-token")}`,
  				},
				data: {
					...values,
				},
			});
			toast.success("User Information Updated Successfully");
			return { data, message: "success" };
		} catch (error) {
			toast.error("Error in updating user information");
			return rejectWithValue(error.response?.data || error.message); // ✅ FIXED
		}
	}
);

const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		clearUser: (state) => {
			state.user = null;
		},
	},
	extraReducers: (builder) => {
		// LOAD ALL STAFF
		builder.addCase(loadAllStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllStaff.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload; // ✅ FIXED
		});

		builder.addCase(loadAllStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});

		// ADD STAFF
		builder.addCase(addStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addStaff.fulfilled, (state) => {
			state.loading = false;
		});

		builder.addCase(addStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});

		// LOGIN USER
		builder.addCase(addUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addUser.fulfilled, (state, action) => {
			state.loading = false;
			state.user = action.payload;
		});

		builder.addCase(addUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});

		// UPDATE USER
		builder.addCase(updateUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateUser.fulfilled, (state) => {
			state.loading = false;
		});

		builder.addCase(updateUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});

		// LOAD SINGLE STAFF
		builder.addCase(loadSingleStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingleStaff.fulfilled, (state, action) => {
			state.loading = false;
			state.user = action.payload;
		});

		builder.addCase(loadSingleStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});

		// DELETE STAFF
		builder.addCase(deleteStaff.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteStaff.fulfilled, (state, action) => {
			state.loading = false;

			const filterUser = state.list.filter(
				(staff) => staff._id !== action.payload // ✅ FIXED
			);

			state.list = filterUser;
		});

		builder.addCase(deleteStaff.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload;
		});
	},
});

export default userSlice.reducer;
export const { clearUser } = userSlice.actions;